// src/utils/roleHelper.js
export const getRoleFromRoleId = (roleId) => {
  const roleMap = {
    1: "Administrateur",
    2: "Demo",
    3: "Presence",
    4: "Presence Pro",
    5: "Presence Ultim",
    6: "Enseignant",
    7: "Presence Free",
  };
  return roleMap[roleId] || "user"; // Fallback à 'user' si `roleId` est inconnu
};


export const checkRoleAccess = (userRoleId, allowedRoles) => {
  if (!Array.isArray(allowedRoles)) {
    console.error("allowedRoles n'est pas un tableau :", allowedRoles);
    return false;
  }
  console.log("User Role ID :", userRoleId, "Allowed Roles :", allowedRoles);
  return allowedRoles.includes(userRoleId);
};